import { MultiTokenUser, UserLoginRequest } from '@jms/model';
import { createAction, props } from '@ngrx/store';

export const shellLoginAction = createAction(
    '[Shell] Login',
    props<{ login: UserLoginRequest, returnUrl: string }>()
);

export const loginAuthorisedAction = createAction(
    '[Shell] loginAuthorised',
    props<{ token: string, returnUrl: string }>()
);

export const shellLoginSuccessAction = createAction(
    '[Shell] Login Success',
    props<{ user: MultiTokenUser, token: string, returnUrl: string }>()
);

export const shellLoginFailedAction = createAction(
    '[Shell] Login Failed',
    props<{ message?: string }>()
);

export const shellLogoutAction = createAction(
    '[Shell] Logout'
);
